import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';
import { InventoryItemEdition } from '../inventory-item/item-types/app';
import { ItemRetailPrice } from '../item-price';
import { ItemFeeRow } from '../item-pricing-table-base/interface';

export interface Edition extends InventoryItemEdition {
  isActive?: boolean;
  defaultRetailPricing: ItemRetailPrice;
  defaultItemFees: ItemFeeRow[];
}

@Component({
  selector: 'inventory-ui-edition-selector',
  templateUrl: './edition-selector.component.html',
  styleUrls: ['./edition-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class EditionSelectorComponent {
  @Input() selectedEditionId!: string;
  @Input() editions!: Edition[];

  @Output() editionSelectionChange = new EventEmitter<string>();

  handleEditionChange(event: MatSelectChange): void {
    this.editionSelectionChange.emit(event.value);
  }
}
